import { Box, Flex, Image, SimpleGrid, Text } from "@chakra-ui/react";
import { Body, H2, Inner, Kicker, Lead, Mono, Section, alpha, useHomeTokens } from "./primitives";

/** #about — Dr Thomas Miller. */
export const About = () => {
  const t = useHomeTokens();
  return (
    <Section id="about">
      <Inner>
        <SimpleGrid columns={{ base: 1, lg: 2 }} gap={{ base: "40px", lg: "56px" }} alignItems="start">
          <Flex direction="column" gap="20px">
            <Kicker>About</Kicker>
            <H2>Dr Thomas Miller</H2>
            <Lead>
              A PhD in Blockchain Security from Queensland University of Technology and a published scholar in the
              field, bringing academic insight to practical business applications.
            </Lead>
            <Lead>
              With over a decade of experience in blockchain development, Dr Miller has a unique vision for how
              technology can foster human connection rather than replace it.
            </Lead>
            <Box
              as="blockquote"
              mt="8px"
              p="26px 28px"
              borderLeft="2px solid"
              borderColor={t.primary}
              bg={alpha(t.primary, 0.05)}
              borderRadius="0 14px 14px 0"
            >
              <Text fontSize="1.1rem" lineHeight="1.6" color={alpha(t.text, 0.82)} fontStyle="italic">
                "Blockchain and decentralized systems allow us to build transparent, accountable businesses that enhance
                human dignity rather than suppressing it. We're creating tools for sovereignty and cooperation, not
                control."
              </Text>
              <Box as="footer" mt="16px">
                <Mono fontSize="11.5px" textTransform="uppercase" color={t.textFaint}>
                  Dr Thomas Miller
                </Mono>
              </Box>
            </Box>
          </Flex>

          <Flex direction="column" gap="16px">
            <Image
              src="/tomprofile.jpeg"
              alt="Dr Thomas Miller"
              loading="lazy"
              w="100%"
              maxW="340px"
              sx={{ aspectRatio: "1" }}
              objectFit="cover"
              borderRadius="20px"
              borderWidth="1px"
              borderColor={t.cardBorder}
              display="block"
            />
            <Flex
              direction="column"
              gap="12px"
              p="26px"
              borderRadius="16px"
              borderWidth="1px"
              borderColor={t.cardBorder}
              bg={t.cardTint}
              maxW="340px"
            >
              <Mono letterSpacing=".12em" color={t.primary}>
                ACADEMIC RESEARCH PARTNERSHIP
              </Mono>
              <Body fontSize=".93rem">
                Several of our supply chain projects have been published in collaboration with Queensland University of
                Technology, bringing academic rigor to our blockchain implementations.
              </Body>
              <Text fontSize="1.5rem" fontWeight="700" letterSpacing="-0.02em" color={alpha(t.text, 0.85)}>
                QUT
              </Text>
            </Flex>
          </Flex>
        </SimpleGrid>
      </Inner>
    </Section>
  );
};
